
import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../component/Header";
import HeaderAudioBook from "../component/HeaderAudioBook";
import BottomNav from "../component/BottomNav";
import BottomNavAudioBook from "../component/BottomNavAudioBook";
import BookList from "../component/BookList";
import Grid from "@material-ui/core/Grid";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Button from "@material-ui/core/Button";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');


//var DEBUG45=true;
var DEBUG45=false;


class BookListViewByPub extends Component {

	constructor(props) {
		super(props);

		//this.state = { forecasts: [], loading: true };
		//alert(props);

		this.state = { headerTitle: "더책", book_url:"/book" };
		this.state = { ...this.state, totalcount: 0, booklist: [], totalcount: 0, curpageidx: 0, loading: true, sortway: 1, sortorder: 1 };
		this.state = { ...this.state, pubname: this.props.location.state.pubname };

                    if( window.location.pathname.toLowerCase().indexOf("audiobook")>0 || 
                       window.location.search.toLowerCase().indexOf("audiobook")>0) {
                         //strHeaderSubTitle = "오디오북 라이브러리";
                         this.state.book_url="/audiobook";
                    } else {
		//strHeaderSubTitle = "더책";
                        this.state.book_url="/book";
                    };


		//alert(JSON.stringify(this.state));

		this.doSort = this.doSort.bind(this);

		this.dogetdata(true);
	
		
	}

	componentWillMount() {
		var self = this;
		window.addEventListener('scroll', function () {
			if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
				if(DEBUG45) console.log("you're at the bottom of the page");
				if (self.state.loading === false) {
					self.dogetdata(false);
				}
			}
		});
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll, true);
	}


	dogetdata(binit) {
		//alert(this.state.booklist.length + ", " + this.state.totalcount + ", " + binit);
		if (binit === false && this.state.booklist.length >= this.state.totalcount)
			return;
		if (binit === false ) this.state.curpageidx= Math.floor(this.state.booklist.length / 50 );

		if (binit === true) {
			this.state.curpageidx = 0;
		}

		this.state.loading = true;

		fetch(`/api/AB/BookListR2?pgidx=${this.state.curpageidx}&pgsize=50&orderby=${this.state.sortway}&orderway=${this.state.sortorder}&searchway=10&srch_publisher=${this.state.pubname}&exact=1`)
			.then(response => response.json())
			.then(data => {
				
				//if(DEBUG45) console.log(JSON.stringify(data.lstresult));
				//alert(data.totalcount);

				this.state.loading = false;

				if (binit === true) {
					this.state.curpageidx = 0;
					this.state.booklist = data.lstresult;
					this.state.curpageidx++;
				}
				else {
					this.state.curpageidx++;
					this.state.booklist.push(...data.lstresult);
				}

				//this.state.booklist.push(...data.lstresult);

				this.setState({ totalcount: data.totalcount, curpageidx: this.state.curpageidx, booklist: this.state.booklist, loading: false });

				//this.dohistorymark();
			});

	}

	doSort(e) {
		var ns = e.currentTarget.name;
	    this.state.curpageidx=0;
		var sortway = 1;
		var sortorder = 1;
		if (ns === 1) {
			sortway = 0;
			sortorder = 0;
		}
		else if (ns === 2) {
			sortway = 0;
			sortorder = 1;
		}
		else if (ns === 4) {
			sortway = 1;
			sortorder = 0;
		}
		else if (ns === 3) {
			sortway = 1;
			sortorder = 1;
		}
		this.state.sortorder = sortorder;
		this.state.sortway = sortway;

		this.dogetdata(true);
	}

	dorender() {
	    return (
			<p className="section-description">&nbsp; {this.state.totalcount} 건의 책이 있습니다.</p>
		);
	}

	dorender2() {
		let bookDummy = this.state.booklist;
		//alert(JSON.stringify(bookDummy));

		return (
			bookDummy.map((book, index) => {
				return (
					<React.Fragment>
						<li className="bookList-item">
							<Link to={`${this.state.book_url}/${book.id}`}>
								<div className="bookList-thumbnail">
									<div className="thumbnail">
										<img
											className="thumbnail-image"
											src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.id}`}
											alt={book.subject}
										/>
									</div>
								</div>
								<div className="bookList-info">
									<h3 className="bookList-title">{book.subject}</h3>
									<h4 className="bookList-author">작가: {book.author_name}</h4>
									<h4 className="bookList-publisher">출판사: {book.publisher_name}</h4>
								</div>
							</Link>
						</li>
					</React.Fragment>
				);
											})

		);
											}

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
											}

    render() {

		let contents = this.state.loading === true
			? <p className="section-description">Loading...</p>
            : this.dorender(); this.logPageView();

		let contents2 = this.state.loading === true
			? <p className="section-description">Loading...</p>
            : this.dorender2(); this.logPageView();

        var hdr;
        var foot;
        if(this.state.book_url.indexOf("audiobook")>-1) {
          hdr= <HeaderAudioBook headerTitle={this.state.headerTitle} />
          foot= <BottomNavAudioBook />
											} else {
          hdr= <Header headerTitle={this.state.headerTitle} />
          foot= <BottomNav />
											}
		return (
			<React.Fragment>
											{hdr}

<br/><p/>
				<div className="section">
					<div className="section-header">
						<h2 className="section-title">
							<Link path="/">{this.state.pubname}</Link>
						</h2>
											{contents}
					</div>
					<div className="section-body">
						<React.Fragment>
							<ExpansionPanelDetails>
								<Grid container spacing={2}>
									<Grid item xs={12}>
										<div className="form-group">
											<h4 className="form-label">정렬</h4>
											<Button variant="contained" className="btn-sm" onClick={this.doSort} name="1">
												ㄱ-ㅎ 순
								</Button> &nbsp;
											<Button variant="contained" className="btn-sm" onClick={this.doSort} name="2">
												ㅎ-ㄱ 순
								</Button>
											&nbsp;&nbsp;
								<Button variant="contained" className="btn-sm" onClick={this.doSort} name="3">
												최신순
								</Button> &nbsp;
											<Button variant="contained" className="btn-sm" onClick={this.doSort} name="4">
												역순
								</Button>
										</div>
									</Grid>
								</Grid>
							</ExpansionPanelDetails>
							<ul className="bookList">
											{contents2}
							</ul>
						</React.Fragment>
					</div>
				</div>

											{foot}
			</React.Fragment>
		);
											}
											}

export default BookListViewByPub;
